import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getFuelStations = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-station/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e.response ? e.response : { message: "An error occurred." };
  }
};

const createFuelStation = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-station/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e.response ? e.response : { message: "An error occurred." };
  }
};

const deleteFuelStation = async (fuelStationId) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-station/?station_id=${fuelStationId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e.response ? e.response : { message: "An error occurred." };
  }
};

const updateFuelStation = async (fuelStationId, data) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-station/?station_id=${fuelStationId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e.response ? e.response : { message: "An error occurred." };
  }
};

const bulkCreateFuelStations = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/fuel-station/`, // Correct template literal
      { stations: data }, // Wrap in 'stations' key
      {
        headers: {
          Authorization: `Bearer ${getToken()}`, // Correct template literal
          "Content-Type": "application/json",
        },
      }
    );
    return res;
  } catch (e) {
    console.error("Bulk create error:", e.response?.data || e.message);
    return e.response || { message: "Bulk upload failed" };
  }
};

export {
  getFuelStations,
  createFuelStation,
  deleteFuelStation,
  updateFuelStation,
  bulkCreateFuelStations,
};
